
























import { Action, State } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";

import AuthPanel from "@/components/AuthPanel.vue";
import ModeButton from "@/components/ModeButton.vue";
import ComputedTime from "@/components/ComputedTime.vue";
import DocumentForm from "@/components/DocumentForm.vue";
import ConceptDetails from "@/components/ConceptDetails.vue";
import DocumentAnalysis from "@/components/DocumentAnalysis.vue";

@Component({
  components: {
    AuthPanel,
    ComputedTime,
    ModeButton,
    DocumentForm,
    DocumentAnalysis,
    ConceptDetails
  }
})
export default class AnalysisView extends Vue {
  @State("text")
  private document!: number;

  @Action("clear")
  reset!: () => void;
}
